import { MarkdownReportText } from './MarkdownReportText';

// One labeled block inside a structured (parsed) Multi-Channel Report -
// shared by ReportsScreen.tsx and PublicChannelViewScreen.tsx's Reports
// tab, both of which render the same evidenceReport.ts output. Renders
// nothing for an empty section rather than an awkward blank heading (the
// LLM occasionally leaves a section terse-but-non-empty per the prompt's
// "say 'None noted.'" instruction, so an empty section here is a
// defensive fallback, not the expected path).
export function EvidenceSection({ title, text }: { title: string; text: string }) {
  if (!text.trim()) return null;
  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-[11px] font-semibold uppercase tracking-wide text-black/40 dark:text-white/40">{title}</span>
      <MarkdownReportText text={text} className="text-[14px]" />
    </div>
  );
}
